export const navbarHeight = 42

export default { navbarHeight }
